<template>
  <div class="basic_level_page">
    <Tabbar :title="$t('account.basicInfo')" />
    <div class="section_content">
      <!-- firstName -->
      <CommonFormItem class="form_item" :label="$t('common.firstName')" required>
        <CommonInput
          v-model="firstName"
          theme="white"
          :placeholder="$t('basicLevel.namePlaceholder')"
          :onInput="($event) => validateInput($event, 1)"
        />
      </CommonFormItem>
      <!-- middleName -->
      <CommonFormItem class="form_item" :label="$t('common.middleName')">
        <CommonInput
          v-model="middleName"
          theme="white"
          :placeholder="$t('basicLevel.namePlaceholder')"
          :onInput="($event) => validateInput($event, 2)"
        />
      </CommonFormItem>
      <!-- lastName -->
      <CommonFormItem class="form_item" :label="$t('common.lastName')" required>
        <CommonInput
          v-model="lastName"
          theme="white"
          :placeholder="$t('basicLevel.namePlaceholder')"
          :onInput="($event) => validateInput($event, 3)"
        />
      </CommonFormItem>
    </div>
    <div class="bottom_btn_box">
      <CommonBtn class="confirm_btn" :text="$t('common.confirm')" :onClick="saveBasicInfo"></CommonBtn>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import CommonFormItem from '@/components/CommonFormItem'
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import { Toast } from 'vant'
import { saveSyncedLastName } from '@/utils'

export default {
  name: 'EditBasicUserInfo',
  components: {
    Tabbar,
    CommonFormItem,
    CommonInput,
    CommonBtn
  },
  data() {
    return {
      firstName: this.$store.state.userInfo.firstName,
      middleName: this.$store.state.userInfo.middleName,
      lastName: this.$store.state.userInfo.lastName
    }
  },
  methods: {
    validateInput(event, type) {
      // 禁止输入符号空格
      const inputValue = event.target.value
      const regex = /^[a-zA-Z]+$/
      if (!regex.test(inputValue)) {
        switch (type) {
          case 1:
            this.firstName = inputValue.replace(/[^a-zA-Z]/g, '')
            break
          case 2:
            this.middleName = inputValue.replace(/[^a-zA-Z]/g, '')
            break
          case 3:
            this.lastName = inputValue.replace(/[^a-zA-Z]/g, '')
            break
        }
      }
    },
    saveBasicInfo() {
      if (!this.firstName || !this.lastName) {
        Toast({ message: this.$t('basicLevel.fieldEmptyToast') })
        return
      }
      const data = {
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName
      }
      this.$http
        .post(window.serverPath + '/api/user/editBaseUserInfo', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            const current = this.$store.state.userInfo || {}
            this.$store.commit('setUserInfo', {
              ...current,
              firstName: this.firstName,
              middleName: this.middleName,
              lastName: this.lastName
            })
            saveSyncedLastName(current.userId, this.lastName)
            Toast(res.data.message)
            this.$router.push({
              name: 'Home'
            })
          } else {
            Toast(this.$t('basicLevel.failToast'))
          }
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped>
.basic_level_page {
  position: relative;
  width: 100%;
  background: #fff;
}

.form_item {
  margin-bottom: 0.12rem;
}

.section_content {
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
}

.bottom_btn_box {
  width: 100%;
  box-sizing: border-box;
  padding: 0.16rem;
}

.confirm_btn {
  width: 100% !important;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/EditBasicUserInfo.vue